import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Tabs, { Tab } from "material-ui/Tabs";
import Table from "../../../../../components/table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import ReactSpeedometer from "react-d3-speedometer";
import { infoData } from "./infoenum";
import SummaryLeftTable from "./summaryLeftTable";
import SummaryRightTable from "./summaryRightTable";
import { preparePager } from "../../../../../common/tabletools";
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  Label,
  Cell
} from "recharts";
import { getCableList } from "../../../../../redux/actions";
class UptimeResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabPosition: 0,
      subtestUptimeResultsDetails: {},
      selectedId: null,
      isUptime: false,
      jumpToPage: "",
      isBarClicked: props.isBarClicked
    };
    this.barClick = this.barClick.bind(this);
  }

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    this.setState({ tabPosition: value });
  };

  renderTooltip() {
    return <div>Custom content</div>;
  }

  formatNumber = number => {
    if (
      (number.toString().split(".")[0] &&
        number.toString().split(".")[0].length > 9) ||
      (number.toString().split(".")[1] &&
        number.toString().split(".")[1].length > 6)
    ) {
      return number.toExponential(3).toUpperCase();
    } else return number;
  };

  barClick(data, index, e) {
    let item = {
      testid: Number(this.props.pager.tid),
      jid: Number(this.props.pager.jid),
      index: data.index,
      pagesize: this.props.pager.pagesize,
      sortfield: this.props.pager.order.field
        ? this.props.pager.order.field
        : null,
      desc: this.props.pager.order.sorttype
        ? this.props.pager.order.sorttype == "asc"
          ? false
          : true
        : false
    };
    this.setState({
      activeIndex: data.index
      //isBarClicked: true
    });
    this.props.changeBarClick(true);
    this.props.getsubtestUptimeResultsDetails_BarClick(item).then(response => {
      let newPager = {
        filtered: [],
        sorted: [],
        global: false,
        jid: item.jid,
        manual: true,
        order: {},
        pageno: response,
        pagesize: item.pagesize,
        search: [],
        tid: item.testid
      };
      this.setState({
        isUptime: true,
        jumpToPage: response - 1
      });
      this.props.getsubtestUptimeResultsDetails(newPager).then(response => {
        // this.props.getsubtestUptimeResultsDetails_BarClick(item).then( pageno=>{
        //   getcall(page).then{ funcio}
        // });
        // console.log(this.props.subtestUptimeResultsDetails_BarClick);
        //this.props.updatePaging(pager);

        let rowIndex = response.data.findIndex(i => i.index === data.index);

        let selectedId = response.data.find(i => i.index === data.index).id;

        this.setState({
          selectedId
        });

        var elmnt = document.getElementsByClassName("rt-tr")[rowIndex];

        elmnt.scrollIntoView();
        elmnt.className += " tableRow1";
      });
    });
  }

  render() {
    const {
      classes,
      result,
      subtest,
      subtestUptimeResults,
      translate,
      chartMeasurementUnit,
      chartMeasurementType,
      pager,
      fetch,
      isBarClicked,
      changeBarClick
    } = this.props;
    let {
      subtestUptimeResultsDetails,
      selectedId,
      isUptime,
      jumpToPage
    } = this.state;

    let { tabPosition } = this.state;

    return subtestUptimeResults &&
      subtestUptimeResultsDetails &&
      subtestUptimeResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestUptimeResults.teststarted
                  ? moment(subtestUptimeResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_duration")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestUptimeResults.testduration}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid2}>
              <div className={classes.gauge}>
                <ReactSpeedometer
                  ringWidth={35}
                  needleHeightRatio={0.5}
                  segments={3}
                  maxValue={100}
                  value={subtestUptimeResults.efficiency}
                  segmentColors={["#ddd", "#ddd", "#ddd"]}
                  needleColor="#000000"
                  textColor={"#000000"}
                  fluidWidth={true}
                  currentValueText="."
                />
              </div>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_efficiency")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestUptimeResults.efficiency.toFixed(3) + "%"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid2}>
              <div className={classes.gauge}>
                <ReactSpeedometer
                  ringWidth={35}
                  needleHeightRatio={0.5}
                  segments={3}
                  maxValue={100}
                  value={subtestUptimeResults.utilization}
                  segmentColors={["#ddd", "#ddd", "#ddd"]}
                  needleColor="#000000"
                  textColor={"#000000"}
                  fluidWidth={true}
                  currentValueText="."
                />
              </div>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_utilization")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestUptimeResults.utilization.toFixed(3) + "%"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_link_speed")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestUptimeResults.linkspeed + " Gb/s"}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "3px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestUptimeResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {infoData.find(o => o.name === subtestUptimeResults.info)
                        ? " " +
                          translate(
                            infoData.find(
                              o => o.name === subtestUptimeResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.tabGrid}>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <Tabs
                value={tabPosition}
                onChange={this.handleTabChange}
                centered={true}
              >
                <Tab
                  key={0}
                  label={translate("summary").toUpperCase()}
                  className={classes.tab}
                />
                <Tab
                  key={1}
                  label={translate("result_detail")}
                  className={classes.tab}
                />
              </Tabs>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
          {tabPosition === 0 && (
            <Grid container>
              <Grid item xs={6}>
                <SummaryLeftTable
                  subtestUptimeResults={subtestUptimeResults}
                  translate={translate}
                  formatNumber={this.formatNumber}
                />
              </Grid>
              <Grid item xs={6}>
                <SummaryRightTable
                  subtestUptimeResults={subtestUptimeResults}
                  translate={translate}
                />
              </Grid>
            </Grid>
          )}
          {tabPosition === 1 && (
            <Grid container>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.bargraph}>
                    <BarChart
                      width={1200}
                      height={220}
                      data={subtestUptimeResults.data}
                      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                      <XAxis
                        dataKey="name"
                        height={60}
                        tickCount={10}
                        domain={[0, "dataMax"]}
                        //ticks={[0, 64800, 129600, 194400, 259200]}
                        tickFormatter={tick => {
                          let f = Math.floor;
                          let g = n => ("00" + n).slice(-2);
                          return (
                            f(tick / 3600) +
                            ":" +
                            g(f(tick / 60) % 60) +
                            ":" +
                            g(tick % 60)
                          );
                        }}
                        type="number"
                      >
                        <Label
                          //angle={270}
                          position="center"
                          style={{ textAnchor: "middle" }}
                          dy={10}
                          domain={[0, "dataMax"]}
                        >
                          {translate("result_testtime")}
                        </Label>
                      </XAxis>
                      <YAxis tickCount={3}>
                        <Label
                          angle={270}
                          position="left"
                          style={{ textAnchor: "middle" }}
                          dx={10}
                          domain={["dataMax", 0]}
                        >
                          {chartMeasurementType == "events"
                            ? translate("chart_measurement_unit_events")
                            : translate("chart_measurement_unit_errors")}
                        </Label>
                      </YAxis>
                      {/* <Tooltip content={this.renderTooltip} /> */}
                      <Tooltip />
                      {/* <Legend /> */}
                      <CartesianGrid strokeDasharray="0 0" />
                      <Bar
                        dataKey={chartMeasurementType == "events" ? "0" : "1"}
                        stackId="a"
                        //fill={this.state.selected ? "#1C408C" : "#290a0a"}
                        // {data.map((entry, index) => (
                        //     <Cell fill={entry.years === "Current" ? '#290a0a' : '#005599' }/>
                        // ))}
                        barSize={25}
                        //onClick={this.handleTickClick}
                        onClick={e => this.barClick(e)}
                      >
                        {subtestUptimeResults.data.map((entry, index) => (
                          <Cell
                            cursor="pointer"
                            fill={
                              isBarClicked &&
                              entry.index === this.state.activeIndex
                                ? "#ff7043"
                                : "#1C408C"
                            }
                            key={`cell-${index}`}
                          />
                        ))}
                      </Bar>
                    </BarChart>
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.div_table}>
                    <Table
                      translate={translate}
                      filterable={false}
                      minRows={0}
                      pages={subtestUptimeResultsDetails.pagecount}
                      manual={pager.manual}
                      defaultPageSize={pager.pagesize}
                      data={subtestUptimeResultsDetails.data}
                      columns={this.state.columns}
                      pager={pager}
                      isUptime={isUptime}
                      jumpToPage={jumpToPage}
                      fetch={fetch}
                      isSGResultView={true}
                      isUptimeView={true}
                      changeBarClick={changeBarClick}
                      style={{
                        border: "none"
                      }}
                      getTrProps={(state, rowInfo, column) => {
                        if (
                          rowInfo &&
                          rowInfo.original &&
                          rowInfo.original.id == selectedId
                        ) {
                          return {
                            style: {
                              background: "#fff5ec"
                            }
                          };
                        }
                        return {};
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const {
      classes,
      getsubtestUptimeResults,
      getsubtestUptimeResultsDetails,
      subtest,
      pager,
      subtestUptimeResultsDetails,
      translate
    } = this.props;
    let pagerNew = {
      manual: true,
      pageno: 1,
      pagesize: 50,
      order: {},
      search: [],
      jid: pager.jid,
      tid: pager.tid,
      global: false
    };
    getsubtestUptimeResults(pager.jid, pager.tid, subtest, null);
    getsubtestUptimeResultsDetails(pagerNew);

    let columns = [];
    let col = null;

    let columnsCount = columns.push(
      {
        id: "id",
        accessor: d => d["id"],
        display: false,
        show: false,
        filterable: false,
        minWidth: 200,
        sortable: false,
        Cell: o => {
          o.original.id;
        }
      },
      {
        id: "time",
        accessor: d => d["time"],
        display: true,
        show: true,
        filterable: false,
        Header: translate("result_testtime"),
        headerStyle: { textAlign: "left" },
        minWidth: 200,
        sortable: true,
        Cell: o => {
          return (
            <React.Fragment>
              <Typography className={classes.table_first_col}>
                {o.row.time
                  ? moment(o.row.time).format("DD/MM/YYYY HH:mm:ss")
                  : ""}
              </Typography>
            </React.Fragment>
          );
        }
      },
      {
        id: "eventscount",
        accessor: d => d["eventscount"],
        display: true,
        show: true,
        filterable: false,
        Header: translate("chart_measurement_unit_events"),
        minWidth: 200,
        sortable: true
      },
      {
        id: "erroredseconds",
        accessor: d => d["erroredseconds"],
        display: true,
        show: true,
        filterable: false,
        Header: translate("chart_measurement_unit_errors"),
        minWidth: 200,
        sortable: true
      },
      {
        id: "frameerrorcount",
        accessor: d => d["frameerrorcount"],
        display: true,
        show: true,
        filterable: false,
        Header: translate("chart_measurement_unit_frame_errors"),
        minWidth: 200,
        sortable: true
      },
      {
        id: "events",
        accessor: d => d["events"],
        display: true,
        show: true,
        filterable: false,
        Header: translate("chart_measurement_unit_events2"),
        headerStyle: { textAlign: "right", paddingRight: "20px" },
        minWidth: 200,
        sortable: false,
        Cell: o => {
          return (
            <React.Fragment>
              <Typography className={classes.table_last_col}>
                {o.row.events
                  ? o.row.events
                      .split(", ")
                      .map((item, i) => (
                        <p className={classes.events}>{item}</p>
                      ))
                  : ""}
              </Typography>
            </React.Fragment>
          );
        }
      }
    );
    if (subtestUptimeResultsDetails) {
      this.setState({
        subtestUptimeResultsDetails
      });
    }

    this.setState({
      columns: columns
    });
  }
  componentWillReceiveProps(nextProps) {
    const {
      getsubtestUptimeResults,
      getsubtestUptimeResultsDetails,
      subtest,
      pager,
      subtestUptimeResultsDetails,
      isBarClicked
    } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestUptimeResults(pager.jid, pager.tid, subtest, null);
      //getsubtestUptimeResultsDetails(pager);
    }
    if (
      this.props.subtestUptimeResultsDetails !== subtestUptimeResultsDetails
    ) {
      this.setState({
        subtestUptimeResultsDetails
      });
      if (this.state.isUptime == true) {
        this.setState({
          isUptime: false,
          jumpToPage: "",
          //activeIndex: "",
          isBarClicked
        });
      }
    }
  }
}

export default withStyles(styles)(UptimeResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/uptime/index.js